import { render, staticRenderFns } from "./DialogLimitedVacancies.vue?vue&type=template&id=3546ac5a&scoped=true&"
import script from "./DialogLimitedVacancies.vue?vue&type=script&lang=js&"
export * from "./DialogLimitedVacancies.vue?vue&type=script&lang=js&"
import style0 from "./DialogLimitedVacancies.vue?vue&type=style&index=0&id=3546ac5a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3546ac5a",
  null
  
)

/* custom blocks */
import block0 from "./DialogLimitedVacancies.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./DialogLimitedVacancies.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle})
